var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _rect4, _path9, _circle, _circle2, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg05Transport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 41,
    viewBox: "0 0 33 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.896484,
    y: 0.958984,
    width: 32,
    height: 28,
    rx: 1,
    fill: "#4841A6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.89648,
    y: 1.95898,
    width: 30,
    height: 26,
    rx: 1,
    fill: "#E7E6F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 28.959H18.8965V39.959C18.8965 40.5113 18.4488 40.959 17.8965 40.959H15.8965C15.3442 40.959 14.8965 40.5113 14.8965 39.959V28.959Z",
    fill: "#E7E6F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 28.959H18.8965V32.0137L14.8965 30.0137L14.8965 28.959Z",
    fill: "#ABA9C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89648 10.959C7.89648 10.4067 8.3442 9.95898 8.89648 9.95898H9.89648V11.959H8.89648C8.3442 11.959 7.89648 11.5113 7.89648 10.959Z",
    fill: "#4841A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 24H13.8965V25C13.8965 25.5523 13.4488 26 12.8965 26H10.8965C10.3442 26 9.89648 25.5523 9.89648 25V24Z",
    fill: "#4841A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8965 24H23.8965V25C23.8965 25.5523 23.4488 26 22.8965 26H20.8965C20.3442 26 19.8965 25.5523 19.8965 25V24Z",
    fill: "#4841A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8965 24H23.8965V25L19.8965 24Z",
    fill: "#353071"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89648 24H13.8965V25L9.89648 24Z",
    fill: "#353071"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8965 10.959C25.8965 10.4067 25.4488 9.95898 24.8965 9.95898H23.8965V11.959H24.8965C25.4488 11.959 25.8965 11.5113 25.8965 10.959Z",
    fill: "#4841A6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.89648,
    y: 8,
    width: 16,
    height: 16,
    rx: 1,
    fill: "#8F87F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.89648,
    y: 9,
    width: 14,
    height: 8,
    rx: 1,
    fill: "#E7E6F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8311 9H22.8997C23.452 9 23.8997 9.44772 23.8997 10V13.9936L11.6415 9H10.8311Z",
    fill: "#ABA9C8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.8965,
    cy: 19.959,
    r: 2,
    fill: "#E7E6F0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.8965,
    cy: 19.959,
    r: 2,
    fill: "#E7E6F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8965 13L16.8994 17",
    stroke: "#8F87F3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg05Transport);
export default __webpack_public_path__ + "static/media/05_transport.e9dfae3c827cdcdce16e90deb2b7cb87.svg";
export { ForwardRef as ReactComponent };